<div class="toast-container">
  @for (toast of toastService.toasts(); track toast.id) {
    <div class="toast" [ngClass]="toast.type">
      <div class="toast-icon">
        <lucide-angular [img]="getIcon(toast.type)" size="20"></lucide-angular>
      </div>
      <div class="toast-content">
        {{ toast.message }}
      </div>
      <button class="toast-close" (click)="toastService.dismiss(toast.id)">
        <lucide-angular [img]="CloseIcon" size="16"></lucide-angular>
      </button>
    </div>
  }
</div>
